import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { auth } from "../firebase";

export default function AdminTaglineEditor() {
    const [tagline, setTagline] = useState({ text: "" });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchTagline = async () => {
            try {
                const token = await auth.currentUser.getIdToken();
                const res = await axios.get("/api/public/tagline", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setTagline(res.data.content);
            } catch (error) {
                console.error("Error fetching tagline:", error);
                toast.error("Error loading tagline");
            } finally {
                setLoading(false);
            }
        };
        
        fetchTagline();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTagline((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const token = await auth.currentUser.getIdToken();
            await axios.put("/api/public/tagline", {
                content: tagline,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Saved!");
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div>
            <h4>Tagline</h4>
            <div className="mb-2">
                <label className="form-label">Text</label>
                <input
                    className="form-control"
                    name="text"
                    value={tagline.text}
                    onChange={handleChange}
                />
            </div>
            <button className="btn btn-admin mt-1" onClick={handleSave} disabled={saving}>
                {saving ? "Saving..." : "Save"}
            </button>
        </div>
    );
}
